import { combineReducers } from 'redux';
import { merge } from 'lodash'
import { normalize, schema } from 'normalizr';

// Define a vinWiseOpening schema
const vinWiseOpeningSchema = new schema.Entity('vinWiseOpenings', {}, { idAttribute: 'vin' });
const vinWiseOpeningListSchema = [vinWiseOpeningSchema];

const defaultVinWiseOpeningParams = {
  vinWiseOpeningFetched: false,
  searchFetched: false,
  isDelFetched: false,
  createTitle: 'Create New Vin Wise Opening',
  createSubmitButtonText: 'Create Vin Wise Opening',
  editTitle: 'Edit Vin Wise Opening',
  editSubmitButtonText: 'Edit Vin Wise Opening'
}


function byId(state = {}, action) {
  if (action.type === 'SAVED_VIN_WISE_OPENING') {
    const vinWiseOpeningID = action.payload.vin;
    if (action.txn === "success") {
      return {
        ...state,
        [vinWiseOpeningID]: action.payload
      }
    } else {
      return state
    }
  }
  if (action.type === 'FETCHED_VIN_WISE_OPENING') {
    const normalizedVinWiseOpening = normalize(action.payload, vinWiseOpeningListSchema);
    return merge({}, state, normalizedVinWiseOpening.entities.vinWiseOpenings)
  }
  if (action.type === 'DELETED_VIN_WISE_OPENING') {
    if (action.payload.msg === "Success") {
      const vinWiseOpeningID = action.payload.id;
      return {
        ...state,
        [vinWiseOpeningID]: {
          ...state[vinWiseOpeningID],
          status: 0
        }
      }
    } else {
      return state
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function searchResults(state = {}, action) {
  if (action.type === 'STORE_SEARCH_VIN_WISE_OPENING_RESULT') {
    const normalizedVinWiseOpening = normalize(action.payload, vinWiseOpeningListSchema);
    return merge({}, normalizedVinWiseOpening.entities.vinWiseOpenings)
  } else {
    return state
  }
}

function filterResults(state = {}, action) {
  if (action.type === 'FILTER_ITEMS') {
    const col = action.payload.col;
    return {
      ...state,
      [col]: action.payload
    }
  } else {
    return state
  }
}

function notifications(state = {}, action) {
  if (action.type === 'SAVED_VIN_WISE_OPENING') {

    return {
      ...state,
      [action.payload.vin]: {
        ...state[action.payload.vin],
        save: {
          status: (action.txn === "success" || action.txn === "Success") ? 'success' : 'error',
          msg: action.msg ? action.msg : (action.txn === "success" || action.txn === "Success") ? 'success' : 'error'
        }
      }
    }
  }
  if (action.type === 'DELETED_VIN_WISE_OPENING') {
    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        delete: {
          status: action.payload.msg === "Success" ? 'success' : 'error',
          msg: action.payload.msg
        }
      }
    }
  }
  if (action.type === 'NOTIFICATION_DONE_VIN_WISE_OPENING') {
    const { id, type } = action.payload
    // Remove the 'id' element from state
    const { [id]: idValue, ...restOfState } = state;
    // Remove the 'type' from the 'id' element
    const { [type]: removedValue, ...restOfId } = idValue;
    // Merge back together
    const finalState = { ...restOfState, [id]: restOfId };
    return finalState

  } else {
    return state
  }
}


function params(state = defaultVinWiseOpeningParams, action) {
  if (action.type === 'FETCHED_VIN_WISE_OPENING') {
    return {
      ...state,
      vinWiseOpeningFetched: true,
      isFetching: false
    }
  } if (action.type === 'SEARCH_VIN_WISE_OPENING') {
    return {
      ...state,
      searchFetched: false,
      isSearching: true,
    }
  }
  if (action.type === 'STORE_SEARCH_VIN_WISE_OPENING_RESULT') {
    return {
      ...state,
      searchFetched: true,
      isSearching: false,
    }
  }
  if (action.type === 'DELETED_VIN_WISE_OPENING') {
    return {
      ...state,
      isDelFetched: true
    }
  } if (action.type === 'SET_VIN_WISE_OPENING_FETCH_OFF') {
    return {
      ...state,
      isDelFetched: false
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultVinWiseOpeningParams
  } else {
    return state
  }
}

const vinWiseOpening = combineReducers({
  byId,
  notifications,
  searchResults,
  params,
  filterResults
});

export default vinWiseOpening;